import crypto from "crypto";

export const generateNonce = (randomSize: number = 16, encoding: string = 'base64') => {
  return crypto.randomBytes(randomSize).toString(encoding);
}